import React from "react";

const BackgroundImage = () => {
  return <div className="indi-header-right-bg"></div>;
};

export default BackgroundImage;
